module.exports = __webpack_public_path__ + "static/media/iconFaceColor.9fdd7d43.svg";